/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AptosSecondlyScheduleControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTokenMetadata(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/secondly/nft/collection/token/meta/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setGeneralSummaryGasPrice2(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/secondly/general/summary/gasprice',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateGeckoPrice(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/secondly/coin/gecko',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setBlockAvgCreatedTime3(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/secondly/block/avgcreatedtime',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTotalSupply(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/secondly/address/totalsupply',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setHomeTotalAccount2(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/secondly/address/total/count',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setHomeTotalBalance2(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/secondly/address/total/balance',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTopAddress(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/secondly/address/topaddress',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setAddressModule(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/secondly/address/signaturemethod',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setActiveValidators(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/secondly/address/activevalidators',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setActivelyStaked(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/secondly/address/activelystaked',
        });
    }

}
